export default {
  /**
   * 法人の操船者一覧を取得
   * @param context
   */
  getUsers: state => state.users,
  /**
   * ページング取得
   * @param state
   * @returns {[]}
   */
  getPageable: state => state.pageable,
}
